<template>
  <div class="installation">
    <div class="form">
      <div class="form-fields">
        <div class="row col-2">
          <div class="col">
            <TextBox
              :label="labels.installationName"
              mandatory
              :invalid="invalidFields.name"
              v-model="modelValue.name"
              @change="onChange('name')"
            ></TextBox>
          </div>
          <div class="col">
            <TextBox
              :label="labels.location"
              v-model="modelValue.location"
              @change="onChange('location')"
              :invalid="invalidFields.location"
              mandatory
            ></TextBox>
          </div>
        </div>
        <div class="row col-1">
          <div class="col">
            <DropList
              :label="labels.application"
              :data="applications"
              v-model="modelValue.application"
              :invalid="invalidFields.application"
              :placeholder="labels.dropdownPlaceholder"
              @change="onChange('application')"
            ></DropList>
          </div>
        </div>
        <div class="row col-1">
          <div class="col">
            <DropList
              :label="labels.segment"
              :data="filteredSegments"
              v-model="modelValue.segment"
              @change="onChange"
              :placeholder="modelValue.application ? labels.dropdownPlaceholder : labels.segmentPlaceholder"
            ></DropList>
          </div>
        </div>
        <div class="row col-2">
          <div class="col">
            <DropList
              mandatory
              :label="labels.product"
              :data="products"
              v-model="modelValue.product"
              @change="onChange('product')"
              :invalid="invalidFields.product"
              :placeholder="labels.dropdownPlaceholder"
            ></DropList>
          </div>
          <div class="col">
            <TextBox
              mandatory
              :label="labels.otherProduct"
              v-model="modelValue.otherProduct"
              @change="onChange('otherProduct')"
              v-if="modelValue.product === labels.other"
              :invalid="invalidFields.otherProduct"
            ></TextBox>
          </div>
        </div>
        <div class="row col-2">
          <div class="col">
            <TextBox
              :label="labels.volume"
              :invalid="invalidFields.volume"
              v-model="modelValue.volume"
              :tooltip="labels.volumeTooltip"
            ></TextBox>
          </div>
          <div class="col">
            <TextBox
              :label="labels.fillDate"
              v-model="modelValue.fillDate"
              @change="onChange"
            ></TextBox>
          </div>
        </div>
        <div class="col row-1">
          <NoteBox :label="labels.feedback" rows="3"
              v-model="modelValue.feedback" class="feedback-note" maxlength="255"></NoteBox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TextBox, CheckboxGroup, Checkbox, DropList, NoteBox } from "clariant-vue3-forms";
import { Labels, Utils } from "../services.js";

export default {
  name: "Installation",
  props: ["modelValue", "lists"],
  components: {
    TextBox,
    CheckboxGroup,
    Checkbox,
    DropList,
    NoteBox
  },
  data() {
    return {
      labels: Labels,
      applications: [],
      segments: [],
      filteredSegments: [],
      products: [],
      metals: [],
      selectedMetals: [false, false, false, false, false, false, false, false],
      invalidFields: {
        name: false,
        location: false,
        application: false,
        product: false,
        otherProduct: false,
        volume: false,
        otherMetals: false
      }
    };
  },
  mounted() {
    if (this.$props.lists) {
      console.log("Lists have data.");
      this.initLists();
    }
  },
  watch: {
    lists(val) {
      console.log("Received new list information");
      this.initLists();
    }
  },
  methods: {
    onChange(field) {
      this.$emit("change", this.modelValue);
      this.$emit("update:modelValue", this.modelValue);
      if (field) {
        if (field === "application") {
          this.updateSegments(this.modelValue.application);
        } 
        this.checkValue(field);
      }
    },
    validateInstallation() {
      let ret = true;

      if (!this.checkValue("name")) ret = false;
      if (!this.checkValue("location")) ret = false;
      if (!this.checkValue("product")) ret = false;
      if (this.modelValue.product === Labels.other) {
        if (!this.checkValue("otherProduct")) ret = false;
      }
      if (this.modelValue.metals.indexOf(Labels.other) !== -1) {
        if (!this.checkValue("otherMetals")) ret = false;
      }

      this.modelValue.invalid = !ret;
      this.$emit("change", this.modelValue);
      this.$emit("update:modelValue", this.modelValue);

      return ret;
    },
    checkValue(field) {
      if (!field) return false;
      if (this.modelValue[field]) {
        this.invalidFields[field] = false;
      } else this.invalidFields[field] = true;
      return !this.invalidFields[field];
    },
    onMetalChanged(ev) {
      let newMetals = [];
      for (let i = 0; i < this.selectedMetals.length; i++) {
        if (this.selectedMetals[i]) {
          newMetals.push(this.metals[i]);
        }
      }
      this.modelValue.metals = newMetals.join("|");
      this.$emit("change", this.modelValue);
      this.$emit("input", this.modelValue);
    },
    initLists() {
      if (!this.$props.lists) return;
      if (this.$props.lists.applications) {
        this.applications = this.$props.lists.applications;
      }
      if (this.$props.lists.products) {
        this.products = this.$props.lists.products;
      }
      if (this.$props.lists.segments) {
        this.segments = this.$props.lists.segments;
      }
      if (this.$props.lists.metals) {
        this.metals = this.$props.lists.metals;
      }
      if (this.modelValue.application) {
        this.updateSegments(this.modelValue.application);
      }
    },
    updateSegments(val) {
      if (!val) return;
      let index = this.applications.findIndex(x => x.id === val);
      if (index >= 0 && index < this.segments.length) {
        this.filteredSegments = this.segments[index];
      }
    }
  }
};
</script>

<style scoped>
.metals {
  display: flex;
  flex-wrap: wrap;
}
.metal-check {
  width: 22%;
}

@media all and (max-width:600px) {
  .metal-check {
    width: 40%;
  }
}
</style>
